import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import TextInput from '../form/TextInput'; //eslint-disable-line import/no-named-as-default
import EmailInput from '../form/EmailInput';//eslint-disable-line import/no-named-as-default
import * as initActions from '../../actions/initActions';
import * as trackingDataActions from '../../actions/trackingDataActions';
import * as dialogPopupActions from '../../actions/dialogPopupActions';
import * as appConstants from '../../constants/appConstants';
import Locale from '../form/LocalePicker';
import * as formValidationHelper from '../../helpers/formValidationHelper';
import * as appHelper from '../../helpers/appHelper';
import * as navHelper from '../../helpers/navigationHelper';
import * as dataHelper from '../../helpers/dataHelper';
import * as keyboardConstants from '../../constants/keyboardConstants';
import {LOCALE_CONFIG} from '../../models/dialogModels';

import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';
import * as localStorage from '../../localStorage/localStorage';

class ActorPrompt extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: props.lang,
            locale_prompt_instruction: appHelper.getLocaleString("locale_prompt_instruction"),
            continue_label: appHelper.getLocaleString("continue_label"),
            updateDialog: false
        };
        this.onContinue = this.onContinue.bind(this);
        this.updateDialog = this.updateDialog.bind(this);
    }

    componentDidMount() {
        this.updateDialog();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: nextProps.lang,
                locale_prompt_instruction: appHelper.getLocaleString("locale_prompt_instruction"),
                continue_label: appHelper.getLocaleString("continue_label"),
                updateDialog: true,
            });
        }
    }

    componentDidUpdate() {
        if(this.state.updateDialog){
            this.updateDialog();
        }
    }

    updateDialog(){
        this.setState({updateDialog: false});
        let title = this.props.contentData.experience.locale[this.state.lang].experience_title;
        let dialogConfig = Object.assign({}, LOCALE_CONFIG, {
            title: title
        });

        this.props.actions.updateDialog(dialogConfig);
    }

    onContinue() {
        this.props.actions.removeDialog();
        let tempInitData = Object.assign({}, this.props.initData, {
            lang_preference_set: true
        });

        this.props.actions.updateInitData(tempInitData);
    }


    render() {
        return (
            <div className="locale-prompt-content">
                <div className="row">
                    <div className="col-xs-12">
                        <div dangerouslySetInnerHTML={{__html: this.state.locale_prompt_instruction}}/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <div className="text-center">
                            <br/>
                            <Locale/>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <div className="text-center">
                            <br/>
                            <button className="btn btn-lg guroo-btn"
                                    onClick={this.onContinue} dangerouslySetInnerHTML={{__html: this.state.continue_label}}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ActorPrompt.propTypes = {
    initData: PropTypes.object.isRequired,
    contentData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

ActorPrompt.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang: lang,
        initData: state.initData,
        contentData: state.contentData,
        trackingData: state.trackingData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, initActions, trackingDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ActorPrompt);



/** WEBPACK FOOTER **
 ** ./src/components/initialisation/LocalePrompt.js
 **/